import { render, staticRenderFns } from "./overseas.vue?vue&type=template&id=b271d1fc&scoped=true"
import script from "./overseas.vue?vue&type=script&lang=js"
export * from "./overseas.vue?vue&type=script&lang=js"
import style0 from "./overseas.vue?vue&type=style&index=0&id=b271d1fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b271d1fc",
  null
  
)

export default component.exports